import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { DeleteRecordingPage } from './delete-recording.page';
import { SquadCastComponentsModule } from '../../components/squadcast.components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild([
      {
        path: '',
        component: DeleteRecordingPage,
      },
    ]),
    SquadCastComponentsModule,
  ],
  declarations: [DeleteRecordingPage],
})
export class DeleteRecordingPageModule {}
